<template>
  <f7-page
    no-toolbar
    no-navbar
    no-swipeback
  >
    <div
      class="m-10"
    >
      <div
        class="sm:flex justify-between"
      >
        <img
          class="order-1 self-start"
          src="@/assets/billing.svg"
          alt="billing"
        >
        <div class="sm:ml-10">
          <div
            class="flex text-center justify-between mt-20"
          >
            <div>
              <div
                class="font-bold text-2xl sm:w-64"
              >
                Tu plan
              </div>
              <div
                class="text-sm"
              >
                {{ users }} Usuarios
              </div>
              <div
                class="w-32 h-10 hover:bg-purple-500 hover:text-white cursor-pointer leading-10 border-solid border border-purple-500 text-purple-500 text-center text-sm rounded-full mx-auto my-2 font-bold"
              >
                Cambiar plan
              </div>
            </div>
            <div class="w-32 h-32">
              <div :class="`h-12 leading-12 text-xl text-white bg-${plan.color}`">
                {{ plan.name }}
              </div>
              <div :class="`text-2xl pt-2 font-bold text-${plan.color}`">
                $ XXX
              </div>
              <div :class="`text-sm font-bold text-${plan.color}`">
                COP / mes
              </div>
            </div>
          </div>
          <credit-card-form
            v-if="addingCard"
            @close="addingCard = false"
          />
          <div
            v-else
            class="w-full my-10 pb-4 shadow-md  bg-white rounded-sm"
          >
            <div
              class="flex justify-between"
            >
              <div
                class="font-bold m-4"
              >
                Medios de pago
              </div>
              <div
                class="cursor-pointer bg-purple-500 text-white self-center flex leading-8 px-2 py-1 rounded-md m-2"
                @click="addingCard = true"
              >
                <eva-icon
                  class="mt-1"
                  name="plus-outline"
                  fill="#FFFFFF"
                />
                <div>
                  Agregar
                </div>
              </div>
            </div>
            <div
              v-for="(paymentMethod, paymentMethodID) in paymentMethods"
              :key="paymentMethodID"
              class="flex justify-around mt-4"
            >
              <img
                class="m-2 w-16"
                :src="paymentMethod.img"
                alt="payment-method"
              >
              <div class="align-self w-16">
                XXXX <b>{{ paymentMethod.id }}</b>
              </div>
              <div
                class="text-purple-500 w-16"
              >
                (Eliminar)
              </div>
            </div>
          </div>
          <div>
            Correo electrónico de facturación
          </div>
          <div
            class="bg-purple-100 rounded-md border px-2 py-1 shadow-md text-xl leading-10 h-12 w-full relative"
          >
            <input
              class="bg-transparent"
              type="text"
            >
          </div>
          <div class="text-lg mt-10 font-bold">
            Facturas anteriores
          </div>
          <div
            v-for="(invoice, invoiceIndex) in invoices"
            :key="invoiceIndex"
            class="h-32 overflow-y-scroll"
          >
            <div
              class="flex"
            >
              <img
                class="m-2"
                src="@/assets/pdf.svg"
                alt="pdf"
              >
              <div class="text-lg leading-12 ml-3">
                {{ formatDate(invoice.timestamp) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment-timezone'
import creditCardForm from '../components/creditCardForm'

export default {
  name: 'Template',
  components: {
    creditCardForm,
  },
  data () {
    return {
      addingCard: false,
      users: 5,
      plans: {
        basic: {
          name: 'Básico',
          unitPrice: 4000,
          color: 'red-500',
          'icon-color': '#FF7570',
        },
        standard: {
          name: 'Estándar',
          unitPrice: 5000,
          color: 'yellow-500',
          'icon-color': '#FFc15E',
        },
        pro: {
          name: 'Pro',
          unitPrice: 6000,
          color: 'green-500',
          'icon-color': '#53DFBA',
        },
      },
      activePlan: 'pro',
      paymentMethods: [
        {
          type: 'credit',
          img: require('@/assets/visa.svg'),
          id: 1124,
        },
        {
          type: 'credit',
          img: require('@/assets/mastercard.svg'),
          id: 9342,
        }
      ],
      invoices: [
        {
          timestamp: Date.now(),
        }
      ],
    }
  },
  computed: {
    plan () {
      return this.plans[this.activePlan]
    },
    ...mapState({
    }),
  },
  watch: {
  },
  async mounted () {
  },
  methods: {
    formatDate (timestamp) {
      return moment(timestamp).format('DD/MM/YYYY')
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";
</style>
